import axios from 'axios'
import { countryConfig } from '../country-config/country-config'

const baseURL = `${countryConfig.baseDomain}`;
const marketingUrl = `${countryConfig.marketingDomain}`;

export const MarketingRepository = axios.create({ baseURL: marketingUrl });
export default axios.create({ baseURL });